import React, { useEffect, useState } from 'react';
import { Button, Input, Space, Select } from 'antd';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { getQueryString } from 'utils/utils';
import { PmCode,  } from 'components/TableSearchBox';
import { addNewSearch } from 'utils/utils';
import 'components/TableSearchBox/index.scss';

const cx = classNames.bind('./index.scss');
export interface MailTemplateSearchBoxProp {}

const MailTemplateSearchBox = ({}: MailTemplateSearchBoxProp): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const navigate = useNavigate();
  const location = useLocation();

  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
   * states
   * ====================================================== */
  const [searchInput, setSearchInput] = useState<string>('');
  const [searchGubun, setSearchGubun] = useState<string|undefined>(undefined);


  /* ======================================================
   * events
   * ====================================================== */
  const onChange = (e) => {
    setSearchInput(e.target.value);
  };

  const onClickReset = (e) => {
    setSearchInput('');
    setSearchGubun('');

    navigate(location.pathname);
  };

  const onSearch = (data: any) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, data),
    });    
  };
  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    const historySearch = getQueryString(location.search);
    (historySearch.search)?setSearchInput(historySearch.search):setSearchInput('');
    if (historySearch.gubun) setSearchGubun(historySearch.gubun);

  }, [location.search]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('tableSearchBoxWrapper')}>
      <Space direction='vertical'>
        <Space>
          <Select
            placeholder={'메일그룹선택'}
            style={{width:'120px'}}
            value={searchGubun}
            onSelect={(value) => {onSearch({ group: value, pageNo: 1 }); setSearchGubun(value);}}
            options={[
              {label: '전체', value:''},              
              {label: '공개과정', value:'lecture'},
              {label: '성과백신', value:'pml'},
              {label: '세미나', value:'seminar'}
            ]}
          />
          <Input.Search
            className={cx('searchInput')}
            value={searchInput}
            placeholder="메일유형명 및 메일 제목을 입력하세요."
            onChange={onChange}
            onSearch={(value)=>onSearch({ search: value, pageNo: 1 })}
            allowClear
          />
          <Button onClick={onClickReset}>
            검색초기화
          </Button>                
        </Space>      
      </Space>
    </div>
  );
};

export default MailTemplateSearchBox;
